export default "/staticreactui/static/media/static/media/customer7.33865945.png";